import { GameScene } from "../scenes/game/GameScene";
import { GameSceneOptions } from "../scenes/game/GameSceneOptions";
import { MenuScene } from "../scenes/menu/MenuScene";
import { AdScene } from "../scenes/popups/ad/AdScene";
import { LoseScene } from "../scenes/popups/lose/LoseScene";
import { LoseSceneOptions } from "../scenes/popups/lose/LoseSceneOptions";
import { PauseScene } from "../scenes/popups/pause/PauseScene";
import { ForceRotateScene } from "../scenes/popups/rotate/ForceRotateScene";
import { SettingsScene } from "../scenes/popups/settings/SettinsScene";
import { VictoryScene } from "../scenes/popups/victory/VictoryScene";
import { VictorySceneOptions } from "../scenes/popups/victory/VictorySceneOptions";

export enum InjectableFactories {
    MenuFactory = "MenuFactory",
    SettingsFactory = "SettingsFactory",
    GameFactory = "GameFactory",
    PauseFactory = "PauseFactory",
    VictoryFactory = "VictoryFactory",
    LoseFactory = "LoseFactory",
    AdFactory = "AdFactory",
    ForceRotateFactory = "ForceRotateFactory"
}

export type MenuFactory = () => Promise<MenuScene>;
export type SettingsFactory = () => Promise<SettingsScene>;
export type GameFactory = (options: GameSceneOptions) => Promise<GameScene>;
export type PauseFactory = () => Promise<PauseScene>;
export type VictoryFactory = (options: VictorySceneOptions) => Promise<VictoryScene>;
export type LoseFactory = (options: LoseSceneOptions) => Promise<LoseScene>;
export type AdFactory = () => Promise<AdScene>;
export type ForceRotateFactory = () => Promise<ForceRotateScene>;
